import { render, staticRenderFns } from "./Jiandian.vue?vue&type=template&id=3bff066c&scoped=true"
import script from "./Jiandian.vue?vue&type=script&lang=js"
export * from "./Jiandian.vue?vue&type=script&lang=js"
import style0 from "./Jiandian.vue?vue&type=style&index=0&id=3bff066c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff066c",
  null
  
)

export default component.exports